import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const setGrouping = createAction(types.SET_GROUPING);
export const setDate = createAction(types.SET_DATE);
export const setFloor = createAction(types.SET_FLOOR);
